import profile_icon from 'src/assets/profile_icon.png';
import letter_w from 'src/assets/letter_w.png';

import React, { useState } from 'react'
import { useContext } from 'react';
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext';
import {
    LeaderboardBody, LeaderboardPageContainer, LeaderboardPrimaryHeader,
    LeaderboardSecondaryHeader, LeaderboardSecondaryHeaderItems
} from './LeaderboardPageStyles';
import { ProfileContext } from 'src/consumer/context/ProfileContext';
import { DisplayFlex } from '../ConsumerProfilePage/ProfileLeftPannelStyle';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import Leaderboard from './Leaderboard';
import YourStats from './YourStats';
import YourBadges from './YourBadges';
import { SetupContext } from 'src/consumer/context/SetupContext';

export default function LeaderboardPage() {

    const navigate = useNavigate();
    const { unSecureSetupData } = useContext(UnsecureSetupContext);
    const [activeHeading, setActiveHeading] = useState('your_stats')

    const { profileData } = useContext(ProfileContext);
    const { setupData } = useContext(SetupContext);

    return (
        <LeaderboardPageContainer>

            <LeaderboardPrimaryHeader isMobile={unSecureSetupData?.clientType === "mobileBrowser"}>
                <DisplayFlex style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
                    <ArrowBackIosIcon sx={{ fontSize: 15, color: 'white' }} />
                </DisplayFlex>
                {/* <LeaderboardProfileImage src={profilePicId ? (isValidHttpUrl(profilePicId) ? profilePicId : mediaURL + profilePicId) : profile_icon} /> */}
            </LeaderboardPrimaryHeader>

            <LeaderboardSecondaryHeader isMobile={unSecureSetupData?.clientType === "mobileBrowser"}>
                <LeaderboardSecondaryHeaderItems onClick={() => setActiveHeading('your_stats')} isActive={activeHeading === 'your_stats'}>Your Stats</LeaderboardSecondaryHeaderItems>
                <LeaderboardSecondaryHeaderItems onClick={() => setActiveHeading('your_badges')} isActive={activeHeading === 'your_badges'}>Your Badges</LeaderboardSecondaryHeaderItems>
                <LeaderboardSecondaryHeaderItems onClick={() => setActiveHeading('leaderboard')} isActive={activeHeading === 'leaderboard'}>Leaderboard</LeaderboardSecondaryHeaderItems>
                {/* <LeaderboardSecondaryHeaderItems onClick={() => setActiveHeading('words_leaderboard')} isActive={activeHeading === 'words_leaderboard'}>Words<LeaderboardSectionIcon src={letter_w} /></LeaderboardSecondaryHeaderItems> */}
            </LeaderboardSecondaryHeader>

            <LeaderboardBody isMobile={unSecureSetupData?.clientType === "mobileBrowser"}>

                {activeHeading === "your_stats" && <YourStats />}
                {activeHeading === "your_badges" && <YourBadges />}
                {activeHeading === "leaderboard" && <Leaderboard profileData={profileData} setupData={setupData} />}
                {/* {activeHeading === "points_leaderboard" && <Leaderboard primaryCriteria="points" />} */}

            </LeaderboardBody>

        </LeaderboardPageContainer>
    )

}
